<template>
  <AppLoader v-if="store.isLoading"/>

  <router-view/>

  <notifications
    position="bottom right"
    classes="otto-notification"
  />
</template>

<script>
  import AppLoader from '@/components/AppLoader'
  import { useMainStore } from '@/stores'

  export default {
    components: { AppLoader },
    setup() {
      const store = useMainStore()

      return {
        store
      }
    },
  }
</script>

<style lang="scss">
  @import "assets/styles";

  .otto-notification {
    // styling
    margin: 0 5px 5px;
    padding: 10px;
    font-size: 14px;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    color: #ffffff;
    border-radius: 4px;

    // default (blue)
    background: #44a4fc;
    border-left: 5px solid #187fe7;

    // types (green, amber, red)
    &.success {
      background: rgba(#42b983, 0.75);
      border-left-color: #42b983;
    }

    &.warn {
      background: rgba(#f48a06, 0.75);
      border-left-color: #f48a06;
    }

    &.error {
      background: #e54d42;
      border-left-color: #b82e24;
    }
  }
</style>
